<template>
    <div id="create-resource-link" class="create-resource">
        <b-form @submit="submit" class="p-2">
            <b-form-group>
                <label for="type">Type</label>
                <b-form-select v-model="selected" :options="options" @change="showInput(selected)"></b-form-select>
            </b-form-group>

            <b-form-group>
                <label for="name">Name</label>
                <b-form-input id="name" name="name" placeholder="Enter Name" required
                              v-model="resourceData.name">
                </b-form-input>
            </b-form-group>

            <b-form-group>
                <div v-if="showLink">
                    <label for="link">Update Link</label>
                    <b-form-input id="link" name="link" placeholder="Enter Link Value" required
                                  v-model="resourceData.link">
                    </b-form-input>
                </div>

                <div v-if="showDocument">
                    <label for="name">Upload File</label>
                    <b-form-file
                        v-model="file1"
                        :state="Boolean(file1)"
                        placeholder="Choose a file or drop it here..."
                        drop-placeholder="Drop file here..."
                    ></b-form-file>
                </div>

                <div v-if="showEvent">
                    <label for="event_date">Choose an Event Date</label>
                    <b-form-datepicker id="event_date" v-model="resourceData.event_date" :min="min" class="mb-2"></b-form-datepicker>

                    <label for="event_time">Choose an Event Time</label>
                    <b-form-timepicker v-model="time_value" :placeholder="formatTime(resourceData.event_date)"
                                       locale="en"></b-form-timepicker>
                </div>

            </b-form-group>
            <b-button type="submit" variant="primary" @click.stop="submit">Submit</b-button>
        </b-form>
        <!-- Loading element -->
        <div id="loading" class="loading" v-if="isLoading">
            <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script>
import moment from "moment";

export default {
    name: 'create-resource-link',

    data() {
        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        // 15th two months prior
        const minDate = new Date(today)
        return {
            min: minDate,
            file1: null,
            isLoading: false,
            resourceData: {},
            selected: null,
            selectedDate: '',
            showDocument: false,
            showEvent: false,
            showLink: false,
            time_value: '',
            options: [
                {value: null, text: 'Please select an option'},
                {value: 'ResourceLink', text: 'Link'},
                {value: 'ResourceDocument', text: 'Document'},
                {value: 'TeamEvent', text: 'Event'}
            ]
        }
    },
    methods: {
        showInput(selected)
        {
            this.showDocument = this.showLink = this.showEvent = false;

            if(selected == 'ResourceDocument'){
                this.showDocument = true;
            }

            if(selected == 'ResourceLink'){
                this.showLink = true;
            }

            if(selected == 'TeamEvent'){
                this.showEvent = true;
            }
        },
        submitFile(evt) {
            evt.preventDefault();
            let _self = this;
            let data = new FormData();
            let endpoint = '/api/resource-document';
            data.append('my_file', _self.file1);
            data.append('name', _self.resourceData.name);

            _self.isLoading = true;
            axios.post(endpoint, data).then(function (response) {
                _self.isLoading = false;
                if (response.data.status === false) {
                    _self.$eventHub.$emit('resource::created', "error");
                } else {
                    _self.$eventHub.$emit('resource::created', "success");
                }
            });
        },
        submitEvent(evt){
            evt.preventDefault();
            let _self = this;
            let endpoint = '/api/team-event';
            _self.resourceData.event_date = _self.selectedDate;
            _self.resourceData.time = _self.time_value;

            let data = {
                resource: _self.resourceData,
            };
            _self.isLoading = true;
            axios.post(endpoint, data).then(function (response) {
                _self.isLoading = false;
                if (response.data.status === false) {
                    _self.$eventHub.$emit('resource::created', "error");
                } else {
                    _self.$eventHub.$emit('resource::created', "success");
                }
            });
        },
        submit(evt) {
            evt.preventDefault();
            let _self = this;

            if (_self.selected === 'ResourceDocument') {
                return _self.submitFile(evt);
            }

            if (_self.selected === 'TeamEvent') {
                return _self.submitEvent(evt);
            }

            let endpoint = '/api/resource-link';
            _self.resourceData.type = _self.selected;
            let data = {
                resource: _self.resourceData,
            };
            _self.isLoading = true;
            axios.post(endpoint, data).then(function (response) {
                _self.isLoading = false;
                if (response.data.status === false) {
                    _self.$eventHub.$emit('resource::created', "error");
                } else {
                    _self.$eventHub.$emit('resource::created', "success");
                }
            });
        },
        formatTime(date){
            return moment(String(date)).format('h:mm')
        }
    },
}

</script>

<style lang="scss">
#loading {
    background: rgba(255, 255, 255, 0.6);
    position: fixed;
    height: 100vh;
    width: 100vw;
    z-index: 10010;
    top: 0;
    left: 0;
    text-align: center;
}

#loading i {
    Position: absolute;
    Top: 50%;
    Transform: translateY(-50%);
}

</style>
